import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=3e91daea&scoped=true&"
import script from "./DatasetDetail.vue?vue&type=script&lang=js&"
export * from "./DatasetDetail.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDetail.vue?vue&type=style&index=0&id=3e91daea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91daea",
  null
  
)

export default component.exports